import Events from '@/events/events'
import { EVENTS } from '../constants/commons'
import { escapeMarkdown, notifyDevs } from './notifyDevs'
import { DEV_ALERT } from '@/project/configs/configs.js'

function truncate(text = '', maxLength = 1000) {
  if (text.length <= maxLength) return text
  return text.slice(0, maxLength) + '\n... (truncated)'
}

export default async function sendBugAlert(
  error,
  context = {},
  sendNotifToUser = true,
) {
  console.error(error)
  const rawMessage = error?.message || String(error)
  const stack = error?.stack || 'N/A'
  const source = context.source || ''

  // Désactiver la notif pour extensions Chrome
  if (source.startsWith('chrome-extension://')) {
    sendNotifToUser = false
  }

  // Désactiver la notif pour "Script error" cross-origin typique sur Chrome mobile
  if (rawMessage === 'Script error.' && stack === 'N/A') {
    sendNotifToUser = false
  }

  sendNotifToUser = false
  if (sendNotifToUser) {
    Events.dispatch(EVENTS.TOAST_NOTIFICATION_REQUESTED, {
      title: 'Erreur détectée ! Notre équipe travaille dessus',
      body: 'Notre équipe travaille dessus ; vous verrez une alerte en haut indiquant l’état de la mise à jour.',
    })
  }

  const MAX_CONTEXT_LENGTH = 1000
  const MAX_STACK_LENGTH = 1000
  const MAX_BASE_MESSAGE_LENGTH = 1500

  const baseMessage =
    rawMessage.length > MAX_BASE_MESSAGE_LENGTH
      ? rawMessage.slice(0, MAX_BASE_MESSAGE_LENGTH) + '\n... (truncated)'
      : rawMessage

  const bugDetails = `
🚨 *Erreur détectée dans l'app \\!*

${sendNotifToUser ? '👀 Notif showed to customer' : "🫣 customer didn't see anything"}

*Message*:
\`${escapeMarkdown(baseMessage)}\`

*Stack*:
\`\`\`
${escapeMarkdown(truncate(stack, MAX_STACK_LENGTH))}
\`\`\`

*Contexte*:
\`\`\`
${escapeMarkdown(truncate(JSON.stringify(context, null, 2), MAX_CONTEXT_LENGTH))}
\`\`\`
`.trim()

  try {
    await notifyDevs(bugDetails, {
      messageAlreadyEscaped: true,
      botToken: DEV_ALERT.ERROR_BOT_TOKEN,
      chatId: DEV_ALERT.ERROR_CHAT_ID,
    })
  } catch (error) {
    console.error(error)
  }
}
